"use client";
import "./funds_risk.scss";
import { useFunds } from "@/contexts/funds-context";
import { Container } from "@/elements/container/container";
import { Text } from "@/elements/text/text";
import { type ReactElement } from "react";

export function FundsRisk(): ReactElement | null {
  const { selectedFund } = useFunds();

  return (
    <section className="funds-risk" aria-label="funds-risk">
      <Container>
        <Text type="h2-semibold" color="neutral-on-surface" htmlElement="p">
          {selectedFund?.introText}
        </Text>
      </Container>
    </section>
  );
}
